import store from '../store/Store';

/**
 * Util to get organizer meeting type ID
 */
export default function getOrganizerMeetingTypeId(): string | null {
    return store.meetingTypeEditState.id;
}
